import { gql, useFragment } from "@apollo/client";

// Constants
import { bgColorFields } from "@/constants/gql-fields";

// Styling
import style from "./header--topnav.module.scss";

// Components
import BackgroundColor from "@/components/bg-color/bg-color";
import Container from "../container/container";
import MenuWP from "../menu-wp/menu-wp";
import SocialIcons from "@/components/social-icons/social-icons";
import SearchIcon from "@/components/search-icon/search-icon";

export default function HeaderTopNav({
  entry,
  menuData,
  searchClickState = {},
}) {
  // Use Fragment
  const menuProps = useFragment({
    fragment: HeaderTopNav.fragments.menu,
    fragmentName: "TopNavMenu",
    from: {
      __typename: "RootQuery",
    },
  });

  const headerProps = useFragment({
    fragment: HeaderTopNav.fragments.entry,
    fragmentName: "TopNavGenSet",
    from: {
      __typename: entry.__typename,
      id: entry.id,
    },
  });

  if (!menuProps.complete || !headerProps.complete) {
    return;
  }

  // Define Variables
  const topNavSettings = headerProps.data.headerContent.topNavSettings;
  const topNavContent = topNavSettings.topNavContent ?? [];
  const topNavOrientation = topNavSettings.topNavOrientation;
  // Header Vars
  const settingsOptions = headerProps.data.headerSettings.options ?? [];

  return (
    <div
      id="topnav"
      className={`${style.headerTopNav} ${
        topNavSettings.whiteText && style.whiteText
      }`}
    >
      {topNavSettings.topnavBackgroundColorColorSettings && (
        <BackgroundColor
          colorSettings={topNavSettings.topnavBackgroundColorColorSettings}
        />
      )}

      <Container width={settingsOptions.includes("container--wide") && "wide"}>
        <div
          className={`${style.headerTopNavContainer}`}
          col-hori={topNavOrientation}
        >
          <MenuWP
            menu={menuProps.data.topNav}
            caratShow="false"
            navStyle="topNav"
          />
          {topNavContent.includes("social") && (
            <SocialIcons id={headerProps.data.id} />
          )}
          {topNavContent.includes("search") && (
            <SearchIcon
              entry={headerProps.data.searchSettings}
              searchClickState={searchClickState}
            />
          )}
        </div>
      </Container>
    </div>
  );
}

HeaderTopNav.fragments = {
  menu: gql`
    fragment TopNavMenu on RootQuery {
      topNav: menu(id: "207", idType: DATABASE_ID) {
        id
        __typename
        ...WpMenuFragment @unmask(mode: "migrate")
      }
    }
    ${MenuWP.fragments.menu}
  `,
  entry: gql`
    fragment TopNavGenSet on GeneralSettingsACF {
      id
      __typename
      headerSettings {
        options
      }
      headerContent {
        topNavSettings {
          topNavContent
          topNavOrientation
          whiteText
          topnavBackgroundColorColorSettings {
           ${bgColorFields}
          }
        }
      }
      searchSettings {
        id
        __typename
        ...SearchIconFragment @unmask(mode: "migrate")
      }
      ...SocialIconsFragment @unmask(mode: "migrate")
    }
    ${SearchIcon.fragments.entry}
    ${SocialIcons.fragments.entry}
  `,
};
